
import React, { ReactNode,useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';

import { QuestionnaireAssignmentModal } from '../components/questionnaire/QuestionnaireAssignmentModal';

import './Start.css';
import { jwtDecode } from "jwt-decode";

interface Props {
  children: ReactNode;
}

interface JwtPayload {
  exp?: number;
  [key: string]: any;
}

export function isTokenValid(token: string | null): boolean {
  if (!token) return false;
  try {
    const { exp } = jwtDecode<JwtPayload>(token);
    if (!exp) return false;
    return Date.now() < exp * 1000;
  } catch {
    return false;
  }
}

export const ProtectedRoute: React.FC<Props> = ({ children }) => {
  const token = localStorage.getItem("token");

  if (!isTokenValid(token)) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export function Start() {
  const navigate = useNavigate();
  const [showAssignmentModal, setShowAssignmentModal] = useState(false);

  const handleAddNewPatient = () => {
    navigate('/admin/patients/new');
  };

  const handleViewAllPatients = () => {
    navigate('/admin/patients');
  };

  const handleAssignQuestionnaire = () => {
    setShowAssignmentModal(true);
  };

  const handleQuestionnaireAnalytics = () => {
    navigate('/admin/analytics');
  };

  return (
    <div 
      className="start-container admin-background"
      style={{
        backgroundImage: 'url(/Login.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed'
      }}
    >
      <div className="start-card card">
        <div className="start-card-body card-body text-center">
          <h1 className="start-title">
            <i className="bi bi-hospital me-3"></i>
            Doctor Portal
          </h1>
          <p className="start-description">
            Welcome to the patient management system. Choose an option below to get started with patient care.
          </p>
          
          <div className="d-grid gap-2">
            <button 
              className="start-button btn btn-primary"
              onClick={handleAddNewPatient}
            >
              <i className="bi bi-person-plus"></i>
              Add New Patient
            </button>
            
            <button 
              className="start-button btn btn-outline-primary"
              onClick={handleViewAllPatients}
            >
              <i className="bi bi-people"></i>
              View All Patients
            </button>

            <button 
              className="start-button btn btn-success"
              onClick={handleAssignQuestionnaire}
            >
              <i className="bi bi-clipboard-check"></i>
              Assign Questionnaire
            </button>

            <button 
              className="start-button btn btn-info"
              onClick={handleQuestionnaireAnalytics}
            >
              <i className="bi bi-graph-up-arrow"></i>
              Questionnaire Analytics
            </button>
          </div>
        </div>
      </div>

      <QuestionnaireAssignmentModal
        show={showAssignmentModal}
        onHide={() => setShowAssignmentModal(false)}
      />
    </div>
  );
}
